// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"vendors-node_modules_gsap_CSSPlugin_js":"973e510f4a3d472dd95a","components_anchor-menu_anchor-menu_js":"86972010feddc62a4e3b"}[chunkId] + ".min.js";
};